import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {RestfulHttpService} from '../httpService/service.service';
import { HttpClient, HttpParams } from '@angular/common/http';
// import * as jwt_decode from 'jwt-decode';

import { environment as env } from '../../../environments/environment';
import {EncryptDataService} from '../encryption/encrypt-data.service';
import {Router} from '@angular/router';
import {NotificationService} from '../notificationServices/notification.service';
import {BootstrapNotifyService} from '../bootstrap-notify/bootstrap-notify.service';
/**
 *
 * Service to handle all api calls to api backend
 */
@Injectable()
export class ApiService extends RestfulHttpService {
  constructor(http: HttpClient,
              private encryptionService: EncryptDataService,
              private router: Router,
              private alertService: BootstrapNotifyService,
              private notification: NotificationService
            ) {
    super(http);
  }

  // isNullOrUndefined(value: unknown): boolean {
  //   return value === null || value === undefined;
  // }
  /**
   *
   * @param error
   * @returns {Observable<never>}
   */
  errorHandler(error) {
    try {

      if (error.error.code === 401 || error.error.message.includes('Access denied') || error.error.message.includes('Unauthenticated')) {
        sessionStorage.clear();
        (<any>$('.modal')).modal('hide');
        localStorage.clear();
        this.router.navigate(['/']);
        this.alertService.error(error.error.message);
        return throwError(error.error || {message: 'Unknown error occurred'});
      }
      return throwError(error || {message: 'Unknown error occurred'});
    } catch (error) {
      return throwError(error || {message: 'Unknown error occurred'});
    }
  }


  /**
   *
   * @param res
   * @param {string} auth
   * @returns {any}
   */
  public decode(res, auth?: string) {
    const data = res.data;
    if (res && res.data) {
      if (auth && auth.match('login')) {
        sessionStorage.setItem(env.TOKEN, data.access_token);
        sessionStorage.setItem(env.USERTOKEN, JSON.stringify(data.user));
      }
      return res;
    } else {
      return res;
    }
  }


  /**
   *
   * @param {string} api
   * @param {string} method
   * @param data
   * @returns {Observable<any>}
   */
  deleteRequest(api: string, method: string, data?: any): Observable<any> {
    let ENDPOINT;
    if (method) {
      ENDPOINT = env.API_URL + '/' + env.API_VERSION + '/' + api + '/' + method;
    } else {
      ENDPOINT = env.API_URL + '/' + env.API_VERSION + '/' + api;
    }
    return super.delete(ENDPOINT, data).retryWhen(error => {
      return error.mergeMap((err) => this.errorHandler(err))
        .delay(1000)
        .take(2);
    }).catch(this.errorHandler).map(res => {
      return res;
    });
  }


  /**
   *
   * @param {string} api
   * @param {string} method
   * @param data
   * @returns {Observable<any>}
   */
  putRequest(api: string, method: string, data: any): Observable<any> {
    let ENDPOINT;
    if (method) {
      ENDPOINT = env.API_URL + '/' + env.API_VERSION + '/' + api + '/' + method;
    } else {
      ENDPOINT = env.API_URL + '/' + env.API_VERSION + '/' + api;
    }
    return super.put(ENDPOINT, data).retryWhen(error => {
      return error.mergeMap((err) => this.errorHandler(err))
        .delay(1000)
        .take(2);
    }).catch(this.errorHandler).map(res => {
      return res;
    });

  }


  /**
   *
   * @param {string} api
   * @param {string} method
   * @param data
   * @returns {Observable<any>}
   */
  patchRequest(api: string, method: string, data: any): Observable<any> {
    let ENDPOINT;
    if (!method) {
      ENDPOINT = env.API_URL + '/' + env.API_VERSION + '/' + api + '/' + method;
    } else {
      ENDPOINT = env.API_URL + '/' + env.API_VERSION + '/' + api;
    }
    return super.patch(ENDPOINT, data).retryWhen(error => {
      return error.mergeMap((err) => this.errorHandler(err))
        .delay(1000)
        .take(2);
    }).catch(this.errorHandler).map(res => {
      return res;
    });
  }


  /**
   *
   * @param {string} api
   * @param {string} method
   * @param {HttpParams} params
   * @returns {Observable<any>}
   */
  getRequest(api: string, method: string, params?: HttpParams): Observable<any> {
    let ENDPOINT;
    if (method) {
      ENDPOINT = env.API_URL + '/' + env.API_VERSION + '/' + api + '/' + method;
    } else {
      ENDPOINT = env.API_URL + '/' + env.API_VERSION + '/' + api;
    }
    return super.get(ENDPOINT, params).retryWhen(error => {
      return error.mergeMap(err => this.errorHandler(err))
        .delay(1000)
        .take(2);
    }).catch( (e) => this.errorHandler(e)).map(res => {
      return res;
    });
  }


  /**
   *
   * @param {string} api
   * @param {string} method
   * @param data
   * @returns {Observable<any>}
   */
  postRequest(api: string, method: string, data: any): Observable<any> {
    let ENDPOINT;
    if (method) {
      ENDPOINT = env.API_URL + '/' + env.API_VERSION + '/' + api + '/' + method;
    } else {
      ENDPOINT = env.API_URL + '/' + env.API_VERSION + '/' + api;
    }
    return super.post(ENDPOINT, data).retryWhen(error => {
      return error.mergeMap((err) => this.errorHandler(err))
        .delay(1000)
        .take(2);
    }).catch(this.errorHandler).map(res => this.decode(res, method));

  }


}


